import { useId } from 'react'

import { cn } from '@/legacy-src/lib/utils'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import { Checkbox } from '@/src/domains/design-system/components/Checkbox'
import { Label } from '@/src/domains/design-system/components/Label'
import { Tag } from '@/src/domains/design-system/components/Tag'
import { Text } from '@/src/domains/design-system/components/Text'

export interface TherapistSessionLocationFilterItemUIProps {
  name: string
  regionName: string
  popular?: boolean
  clinic?: boolean
  displayRegion?: boolean
  checked: boolean
  onChange: (checked: boolean) => void
}

export const TherapistSessionLocationFilterItemUI = ({
  name,
  regionName,
  popular = false,
  clinic = false,
  displayRegion = false,
  checked,
  onChange,
}: TherapistSessionLocationFilterItemUIProps) => {
  const { t } = getTranslate()

  const id = useId()

  return (
    <div className="inline-flex items-center gap-3">
      <Checkbox checked={checked} onCheckedChange={onChange} id={id} />
      <Label
        variant="selection-control"
        htmlFor={id}
        className={cn('grow', {
          'flex flex-col overflow-hidden': displayRegion,
        })}
      >
        <span
          className={cn('align-middle', {
            'flex items-center gap-2': displayRegion,
          })}
        >
          <Text element="span" weight="bold">
            {name}
          </Text>
          {popular ? (
            <Tag size="s" variant="yellow" className="flex-shrink-0">
              {t('component.therapist.filter.event-location.popular.tag')}
            </Tag>
          ) : null}
          {clinic ? (
            <Tag size="s" variant="blue" className="flex-shrink-0">
              {t('component.therapist.filter.event-location.clinic.new')}
            </Tag>
          ) : null}
        </span>
        {displayRegion ? null : <span> </span>}
        <Text className="align-middle" variant="sm" element="span">
          {displayRegion
            ? `${t('component.therapist.filter.event-location.types.district')}, ${regionName}`
            : t('component.therapist.filter.event-location.types.district')}
        </Text>
      </Label>
    </div>
  )
}
